import { ChangeEvent, useContext } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { produce } from "immer";

import InputGlobal from "shared/components/Form/InputGlobal";
import { WizardData } from "shared/components/WizardNew/types";

import { WizardStore, WizardType } from "shared/context/WizardStoreContext";

import { simplyClick } from "shared/helpers/analytics";

import { useWizard, WizardStep } from "shared/hooks/useWizard";

import styles from "@platformAssets/components/Wizard.module.scss";

type Props = { wizardData: WizardData };

const WizardInput = ({ wizardData }: Props) => {
  const { pathname } = useLocation();
  const { t } = useTranslation("wizardNew");

  const wizard = useWizard(wizardData);

  const step = pathname.replace("/", "") as WizardStep;

  const [wizardStore, setWizardStore] = useContext(WizardStore);

  const field = wizard[step]?.fieldArea;

  const inputValue = wizardStore.answers?.[step] ?? "";

  const setAnalyticsEvent = () => {
    if (inputValue.length > 0) {
      wizard[step]?.analytics?.choose?.forEach((item: string) => {
        simplyClick(item, null, false);
      });
    }
  };

  const isValid = inputValue.length <= 255;

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const stringValue = event?.target?.value;

    setWizardStore(
      produce(wizardStore, (wizard: WizardType) => {
        wizard.answers[step] = stringValue;
      })
    );
  };

  if (!field) return null;

  return (
    <div className={styles.wizardRangeWrapper} key={field?.placeholder}>
      <div className={styles.wizardRangesContainer}>
        <InputGlobal
          handleChange={handleChange}
          name={field?.name}
          animatePlaceholder
          onBlur={setAnalyticsEvent}
          placeholder={field?.placeholder}
          value={inputValue}
        />
      </div>

      {!isValid && (
        <p className={styles.errorText}>{t("occupation.invalid")}</p>
      )}
    </div>
  );
};

export { WizardInput };
